import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatModifyDate } from "../../components/Common/CommonLogic";
import { MybookingssBreadcrumb } from "../../common/data/parties";
import StatsSummary from "../../components/GlobalComponent/StatsSummaryComponent";
import FilterSalesInquiryComp from "../Sales/partials/FilterSalesInquiryComp";
import Page from "../../components/GlobalComponent/PageComponent";
import ViewDetails from "./modal/ViewDetails";
import { SMART_QUOTATION_VALUE_UPDATE } from "../../store/InstantRate/actionType";
import MyBookingTable from "./component/MyBookingTable";
import PriceBreakDownModal from "../../components/GlobalComponent/PriceBreakDownModal";
import { getMyBookingRequestData } from "../../store/InstantRate/actions";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { CheckCheck, CircleSlash, CircleX, CloudUpload } from "lucide-react";
import { QueriesColVal } from "../Sales/partials/SalesCol";
import { getTenantQuotationSummeryById } from "../../store/Sales/actions";
import BookingAction from "./modal/BookingAction";
import { BOOKINGS_STATUS_INIT } from "../../store/Sales/actiontype";

const MyBookings = () => {
    document.title = "My Bookings || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    const { instantBookingRequestData, instantBookingRequestLoader } = useSelector((state) => state?.instantRate);
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();
    const [isPriceBreakDownModalOpen, setIsPriceBreakDownModalOpen] = useState(false);
    const tableRef = useRef(null);
    const boxRef = useRef(null);
    const dispatch = useDispatch();
    const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);
    const [inquiriesId, setInquiriesId] = useState();
    const [inquiriesType, setInquiriesType] = useState();
    const [isRight, setIsRight] = useState(false);
    const [quotationData, setQuotationData] = useState();
    const [bookingId, setBookingId] = useState(null);
    const [requestAction, setRequestAction] = useState(false);
    const [actionType, setActionType] = useState('');
    const [locationFrom] = useState('mybooking');
    const [quotationId, setQuotationId] = useState("");

    const inputArr = {
        org_port: '',
        dest_port: '',
        status: '',
        valid_from: '',
        valid_to: '',
        customer: '',
        sales_employee: '',
        isExcelGenerated: false
    }
    const [filterDetails, setfilterDetails] = useState(inputArr);

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const constructUrl = (page, filters) => {
        let url = `?page=${page}&size=${filterDetails?.isExcelGenerated ? inquiry_data?.totalElements : 10}&`;
        url += `${filters?.customer?.id ? `customers=${filters?.customer.id}&` : ''}`;
        url += `${filters?.org_port?.id ? `origins=${filters?.org_port.id}&` : ''}`;
        url += `${filters?.dest_port?.id ? `destinations=${filters?.dest_port.id}&` : ''}`;
        url += `${filters?.sales_employee?.id ? `salesEmployees=${filters?.sales_employee.id}&` : ''}`;
        url += `${filters?.valid_from ? `validFrom=${filters?.valid_from}&` : ''}`;
        url += `${filters?.valid_to ? `validTo=${filters?.valid_to}&` : ''}`;
        url += `${filters?.status?.id ? `status=${filters?.status?.id}&` : ''}`;
        url += `${filters?.container_type?.id ? `containerType=${filters?.container_type?.id}&` : ''}`;
        url += `${filterDetails?.isExcelGenerated ? `isExcelGenerated=${true}&` : ''}`;
        url += 'requestForRates=false&';
        return url.substring(0, url.length - 1); // Remove trailing '&'
    };

    const applyFilterHandler = () => {
        setIsRight(false);
        filterDetails.isExcelGenerated = false;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getMyBookingRequestData(url));
    };

    const clearValueHandler = () => {
        setIsRight(false);
        setfilterDetails(inputArr);
        let url = constructUrl(currentPage, {});
        dispatch(getMyBookingRequestData(url));
    };

    useEffect(() => {
        dispatch({ type: SMART_QUOTATION_VALUE_UPDATE, payload: { quote_currency: {} } });
        //let url = constructUrl(currentPage, filterDetails);
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?isMyBookings=true&page=${currentPage}&size=25`;
            dispatch(getMyBookingRequestData(url));
        }
        console.log("hit this");
    }, [dispatch, currentPage]);

    const downLoadExcelReport = () => {
        filterDetails.isExcelGenerated = true;
        let url = constructUrl(currentPage, filterDetails);
        //dispatch(getSalesInquiryData(url));
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                setShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [boxRef]);

    const handleClose = () => {
        setShow(false);
    }

    const handleOnSellerIdClick = (sellerId, rowRect) => {
        //dispatch(getQuotationSellerListById(sellerId));
        setRowData(rowRect)
    }

    const viewBids = (data) => {
        console.log(data);
        navigate('/view/bids', {
            state: {
                data: data
            },
        });
    };

    const toggleViewDetails = () => {
        setIsViewDetailsOpen(!isViewDetailsOpen);
    }

    const viewDetails = (objData) => {
        setInquiriesType(objData?.rateType || "");
        setInquiriesId(objData?.inquiryId);
        setBookingId(objData?.bookingSummeryId || null);
        toggleViewDetails();
    }

    const QuoteModalHandler = (data) => {
        console.log(data, "data");
        setQuotationId(data?.quotationId);
        setInquiriesType(data?.rateType || "")
        setInquiriesId(data?.inquiryId)
        priceBreakDownModalHandler();
        dispatch(getTenantQuotationSummeryById(data?.quotationId));
    }

    const priceBreakDownModalHandler = () => {
        setIsPriceBreakDownModalOpen(!isPriceBreakDownModalOpen);
    }

    const reqestAction = (dataObj, actionType) => {
        setQuotationData(dataObj);
        console.log(dataObj);
        setActionType(actionType);
        setRequestAction(true);
    }

    const onRefresh = () => {
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?isMyBookings=true&page=${currentPage}&size=25`;
            dispatch(getMyBookingRequestData(url));
        }
    }

    const columns = useMemo(() => [
        {
            Header: 'Inquiry Type',
            accessor: 'rateType',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{cellProps.row.original?.rateType?.replace("_", " ") || '-'}</span>
                );
            }
        },
        {
            Header: 'Booking Dt',
            accessor: 'quotationDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{formatModifyDate(cellProps.row.original?.quotationDate)}</span>
                )
            }
        },
        {
            Header: 'Inquiry ID',
            accessor: 'inquiryId',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Booking ID',
            accessor: 'bookingSummeryId',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },

        {
            Header: 'Origin',
            accessor: 'originPortName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Destination',
            accessor: 'destinationPortName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Cargo Ready Date',
            accessor: 'cargoDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                const cargoDate = cellProps.row.original?.cargoDate;
                const cargoDateSplit = typeof cargoDate === "string" ? cargoDate.split('/') : [];
                return (cargoDateSplit[0] !== "" && cargoDateSplit[1] !== "") ? (
                    <span>{formatModifyDate(cargoDateSplit[0])}/{formatModifyDate(cargoDateSplit[1])}</span>
                ) : <span>/</span>;
            }
        },
        {
            Header: 'Cargo Details',
            accessor: 'cargoDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={(e) => {
                        e.stopPropagation();
                        viewDetails(cellProps.row.original);
                    }}>
                        <span className="align-content-center">View Details</span>
                    </label>
                )
            }
        },
        {
            Header: 'Quotation Details',
            accessor: 'quotationDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={(e) => {
                        e.stopPropagation();
                        QuoteModalHandler(cellProps.row.original);
                    }}>
                        <span className="align-content-center">View Details</span>
                    </label>
                )
            }
        },
        // {
        //     Header: 'Documents',
        //     accessor: 'documents',
        //     filterable: true,
        //     disableFilters: true,
        //     Cell: (cellProps) => {
        //         return (
        //             <label className="form-label" onClick={(e) => {
        //                 e.stopPropagation();
        //                 viewDetails(cellProps.row.original);
        //             }}>
        //                 <span className="align-content-center">View Details</span>
        //             </label>
        //         )
        //     }
        // },
        {
            Header: 'Status',
            accessor: 'statusName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Action',
            Cell: (cellProps) => {
                return (
                    <UncontrolledDropdown>
                        <DropdownToggle className="btn btn-link text-muted py-1 font-size-16 shadow-none" tag="a">
                            <i className='bx bx-dots-vertical-rounded'></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className={cellProps.row.original?.statusCode === 'CUST_APPRVD_PENDING' || !cellProps.row.original?.isExpired ? '' : 'disabled-item'} disabled={cellProps.row.original?.statusCode === 'CUST_APPRVD_PENDING' || !cellProps.row.original?.isExpired ? false : true} onClick={(e) => { e.stopPropagation(); dispatch({ type: BOOKINGS_STATUS_INIT }); reqestAction(cellProps.row.original, 'accept') }}>Approve <CheckCheck size={18} className="me-2 text-secondary" /></DropdownItem>
                            <DropdownItem className={cellProps.row.original?.statusCode === 'CUST_APPRVD_PENDING' || !cellProps.row.original?.isExpired ? '' : 'disabled-item'} disabled={cellProps.row.original?.statusCode === 'CUST_APPRVD_PENDING' || !cellProps.row.original?.isExpired ? false : true} onClick={(e) => { e.stopPropagation(); dispatch({ type: BOOKINGS_STATUS_INIT }); reqestAction(cellProps.row.original, 'reject') }}>Cancel <CircleX size={18} className="me-2 text-secondary" /></DropdownItem>
                            {/* <DropdownItem onClick={(e) => { e.stopPropagation(); viewPopupHandler(cellProps.row.original) }}>Documents <CloudUpload size={18} className="me-2 text-secondary" /></DropdownItem> */}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                )
            }
        },
    ], [instantBookingRequestData]);

    const myBookingsStatsData = [
        {
            title: 'Bookings Requested',
            value: instantBookingRequestData?.bookingsRequested,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Bookings confirmed',
            value: instantBookingRequestData?.bookingsConfirmed,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Bookings in Progress',
            value: instantBookingRequestData?.bookingsInProgress,
            percentage: 0,
            rate: '',
            rateType: 'up'
        },
        {
            title: 'Bookings Cancelled',
            value: instantBookingRequestData?.bookingsCancelled,
            percentage: 0,
            rate: '',
            rateType: 'down'
        }
    ];

    return (
        <>
            <Page>
                <StatsSummary
                    breadcrumb={MybookingssBreadcrumb}
                    stats={myBookingsStatsData}
                />
                {/* Wokring Leter */}
                {/* <MyBookingsItems /> */}
                <MyBookingTable
                    tableRef={tableRef}
                    columns={columns}
                    data={!!instantBookingRequestData.content ? instantBookingRequestData.content : []}
                    isGlobalFilter={true}
                    isAddInvoiceList={true}
                    loader={instantBookingRequestLoader}
                    customPageSize={25}
                    toggleRightCanvas={toggleRightCanvas}
                    downLoadExcelReport={downLoadExcelReport}
                    component={'myBookings'}
                    setCurrentPage={setCurrentPage}
                    totalPages={instantBookingRequestData?.totalPages || 0}
                    totalEntries={instantBookingRequestData?.totalElements || 0}
                />
                <ViewDetails isOpen={isViewDetailsOpen} inquirieType={inquiriesType} inquirieId={inquiriesId} toggle={toggleViewDetails} bookingId={bookingId} />
            </Page>
            <FilterSalesInquiryComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />
            {isPriceBreakDownModalOpen && <PriceBreakDownModal quotationId={quotationId} isPriceBreakDownModalOpen={isPriceBreakDownModalOpen} quotationData={quotationData} priceBreakDownModalHandler={priceBreakDownModalHandler} inquiriesType={inquiriesType} />}
            {requestAction && <BookingAction actionOpen={requestAction} setActionOpen={setRequestAction} quotationData={quotationData} actionType={actionType} locationFrom={locationFrom} onRefresh={onRefresh} />}
        </>
    );
};

export default MyBookings;
